"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getControlFlowOpcodeTemplates = getControlFlowOpcodeTemplates;
function getControlFlowOpcodeTemplates() {
    return `
                        // Control Flow
                        case opMap[50]: { // JUMP
                            pc = decodeJump(jumpTargets[pc]);
                            break;
                        }

                        case opMap[51]: { // JUMP_IF_TRUE
                            if (stack.pop()) {
                                pc = decodeJump(jumpTargets[pc]);
                            } else {
                                pc++;
                            }
                            break;
                        }

                        case opMap[52]: { // JUMP_IF_FALSE
                            if (!stack.pop()) {
                                pc = decodeJump(jumpTargets[pc]);
                            } else {
                                pc++;
                            }
                            break;
                        }

                        case opMap[53]: { // JUMP_NULLISH
                            let val = stack.pop();
                            if (val !== null && val !== undefined) {
                                pc = decodeJump(jumpTargets[pc]);
                            } else {
                                pc++;
                            }
                            break;
                        }

                        case opMap[54]: { // CALL
                            let argCount = stack.pop();
                            let fn = stack.pop();
                            stack.push(fn.apply(undefined, collectArgs(stack, argCount)));
                            pc++;
                            break;
                        }

                        case opMap[55]: { // CALL_METHOD
                            let argCount = stack.pop();
                            let method = stack.pop();
                            let obj = stack.pop();
                            if (typeof method !== 'function') {
                                throw new TypeError(method + ' is not a function');
                            }
                            stack.push(method.apply(obj, collectArgs(stack, argCount)));
                            pc++;
                            break;
                        }                            

                        case opMap[56]: { // RETURN
                            if (exceptionHandlers.length > 0) {
                                let handler = exceptionHandlers[exceptionHandlers.length - 1];
                                if (handler.finallyIndex !== undefined) {
                                    pendingReturn.hasReturn = true;
                                    pendingReturn.value = stack.pop();
                                    pc = handler.finallyIndex;
                                    break;
                                }
                            }
                            if (pendingReturn.hasReturn) {
                                pendingReturn.hasReturn = false;
                                pendingReturn.value = undefined;
                            }
                            return stack.pop();
                        }

                        case opMap[57]: { // THROW
                            throw stack.pop();
                        }

                        case opMap[63]: { // BREAK
                            if (exceptionHandlers.length > 0) {
                                let handler = exceptionHandlers[exceptionHandlers.length - 1];
                                if (handler.finallyIndex !== undefined) {
                                    pendingBreak.hasBreak = true;
                                    pendingBreak.target = decodeJump(jumpTargets[pc]);
                                    pc = handler.finallyIndex;
                                    break;
                                }
                            }
                            pc = decodeJump(jumpTargets[pc]);
                            break;
                        }

                        case opMap[64]: { // CONTINUE
                            if (exceptionHandlers.length > 0) {
                                let handler = exceptionHandlers[exceptionHandlers.length - 1];
                                if (handler.finallyIndex !== undefined) {
                                    pendingContinue.hasContinue = true;
                                    pendingContinue.target = decodeJump(jumpTargets[pc]);
                                    pc = handler.finallyIndex;
                                    break;
                                }
                            }
                            pc = decodeJump(jumpTargets[pc]);
                            break;
                        }
    `;
}
